export const livwellnow = {
	PAGE_THEME_ENABLED: false,
};
